<template>
    <div class="broker-system">
      <div class="broker-system-header a-3-bd clearfix">
        <c-navTab
          activeClassName="b-1-cl"
          activeColor="a-12-bg"
          className="b-2-cl"
          :currentTab="currentTab"
          :navTab="navTab"
          :lineHeight="lineHeight"
          :marginRight="marginRight"
          @currentType="currentType"
        />
      </div>
      <div class="broker-user-info a-7-bd" :style="customStyle">
        <!-- 用户名称 -->
        <div class="user-name">
          <!-- <div class="top b-2-cl">{{reqData.roleName}}</div> -->
          <div class="phone b-1-cl">{{ reqData.accountName }}</div>
        </div>
        <!-- 邀请总人数 -->
        <div class="user-text a-4-bg">
          <span class="title b-2-cl">{{$t('brokerSystem.homeText[1]')}}</span>
          <span class="info b-1-cl">{{ reqData.totalUser }}</span>
        </div>
        <!-- 累计返佣 -->
        <div class="user-text a-4-bg">
          <span class="title b-2-cl">{{$t('brokerSystem.homeText[2]')}}</span>
          <span class="info b-1-cl">{{ reqData.totalReturnAmount }}{{ reqData.returnCoin }}</span>
        </div>
        <!-- 推广助手 -->
        <c-button
          class="invite-help b-4-cl"
          @click="inviteHelp"
          type="text">
          {{$t('brokerSystem.navTab[4]')}}
        </c-button>
      </div>
      <div class="broker-content">
        <overview v-show="currentTab===1"/>
        <Commission v-if="currentTab===2"/>
        <Lower v-if="currentTab===3"/>
        <TradeSearch v-if="currentTab===4"/>
        <Invite v-if="currentTab===5"/>
      </div>
      <c-dialog :showFlag="dialogFlag"
            paddingBottom="14px"
            paddingTop="14px"
            :confirmLoading="dialogConfirmLoading"
            :confirmDisabled="dialogConfirmDisabled"
            @close="dialogClose"
            @confirm="dialogConfirm"
            :titleText="$t('personal.userManagement.otherList.myInviteCod.text')">
      <div class="dialog-div a-4-bg">
        <div class="dialog-div-module a-5-bd">
          <p>{{$t('personal.label.inviteCode')}}</p>
          <p>
            <span class="b-2-cl">{{inviteCode}}</span>
            <span @click="copyClick('inviteCode')"
                  @mouseenter="handMouseenter('inviteCode')"
                  @mouseleave="handMouseleave('inviteCode')">
              <span v-if="inviteCodeShow">
                  <svg class="icon icon-14"
                       aria-hidden="true">
                    <use xlink:href="#icon-a_9"></use>
                  </svg>
                </span>
              <span v-else>
                  <svg class="icon icon-14"
                       aria-hidden="true">
                    <use xlink:href="#icon-a_9_1"></use>
                  </svg>
              </span>
            </span>
          </p>
        </div>
        <div class="dialog-div-module a-5-bd">
          <p>{{$t('personal.label.inviteUrl')}}</p>
          <p>
            <span class="b-1-cl">{{inviteUrl}}</span>
            <span @click="copyClick('inviteUrlShow')"
                  @mouseenter="handMouseenter('inviteUrlShow')"
                  @mouseleave="handMouseleave('inviteUrlShow')">
              <span v-if="inviteUrlShow">
                  <svg class="icon icon-14"
                       aria-hidden="true">
                    <use xlink:href="#icon-a_9"></use>
                  </svg>
                </span>
              <span v-else>
                  <svg class="icon icon-14"
                       aria-hidden="true">
                    <use xlink:href="#icon-a_9_1"></use>
                  </svg>
              </span>
            </span>
          </p>
        </div>
        <div class="dialog-div-module a-5-bd">
          <p>{{$t('personal.label.inviteQECode')}}</p>
          <div class="img-div a-5-bg">
            <img :src="inviteQECode"/>
          </div>
        </div>
      </div>
    </c-dialog>
    </div>
</template>

<script>
import mixin from 'BlockChain-ui-privatization/PC/common-mixin/personal/brokerSystem/index/index';
import 'BlockChain-ui-privatization/PC/common-mixin/personal/brokerSystem/index/index.styl';
import overview from './overview.vue';
import Commission from './commission.vue';
import Lower from './lower.vue';
import TradeSearch from './tradeSearch.vue';
import Invite from './invite.vue';

export default {
  mixins: [mixin],
  mounted() {
    this.init();
  },
  components: {
    Commission,
    Lower,
    TradeSearch,
    Invite,
    overview,
  },
};
</script>
